export default [
  {
    path: '/real-estate-developments/:id/medias/new',
    name: 'RealEstateDevelopmentsMediasCreate',
    component: () => import('pages/real-estate-developments/tabs/medias/MediasForm.vue')
  },
  {
    path: '/real-estate-developments/:parentId/medias/:id',
    name: 'RealEstateDevelopmentsMediasSingle',
    component: () => import('pages/real-estate-developments/tabs/medias/MediasSingle.vue')
  },
  {
    path: '/real-estate-developments/:parentId/medias/:id/edit',
    name: 'RealEstateDevelopmentsMediasEdit',
    component: () => import('pages/real-estate-developments/tabs/medias/MediasForm.vue')
  }
]
